/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, PureComponent } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import ReactPlayer from 'react-player';
// import { findDOMNode } from 'react-dom';
import screenfull from 'screenfull';
import Hotkeys from 'react-hot-keys';
//import parse from 'html-react-parser';

// import DateLine from '../containers/live/DateLine';
// import DateTimeLine from '../containers/live/DateTimeLine';
import ContentPart from '../containers/live/ContentPart';
import SameGenreContent from '../containers/main/SameGenreContent';
import SameTimeContent from '../containers/main/SameTimeContent';
import PopularContent from '../containers/main/PopularContent';
import BarBannerItem from '../components/banner/BarBannerItem';
// import ChatHead from '../containers/live/ChatHead'
// import Loader from 'react-loader-spinner';

import Footer from '../components/Footer';
import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from 'react-confirm-alert';         //알럿창(alert confirm)
import InfoLeft from '../containers/live/InfoLeft';

/*채팅 관련 */

// import Layout from '../components/chat/Layout'
import LiveCurrentTitle from '../components/player/LiveCurrentTitle';
// import Tooltip from '@material-ui/core/Tooltip';
// import { _debounce } from 'lodash';
import $ from 'jquery';
import { Base64 } from 'js-base64';
import { Helmet } from 'react-helmet-async';
import { isMobile, isAndroid, isIOS } from 'react-device-detect';

// const _keyStr = "C012V45c6ky89AbdeBDFxHGIKwzLNrOPMST*UW-XZa7fgEhijJlnQRo3pYqstuvm_"

class LivePlayer extends PureComponent {
  state = {
    playing: true,
    played: 0,
    loaded: 0,
    muted: true,
    duration: 0,
    volume: 0.5,
    playbackRate: 1.0,
    pip: false,
    partShow: false,
    mouseScreen: false,
    playBannerShow: true,
    loadingShow: true,
    settingShow: false,
    chatOn: false,
    isHovering: true,

    isSetting: false,
    isFullScreen: false,
    menuBackOn: false,
    menuPart: false,
    menuPlay: false,
    //menuPrev10: false,
    //menuNext10: false,
    menuVolume: false,
    //menuSetting: false,
    menuFull: false,
    menuPip: false,
    menuSound: false,
    logoPlay: false,
    videoUrl: 'https://jjmp4.ofscdn.com/TveeMovie/aniplus/logoANI.mp4',
    url: 'https://jjmp4.ofscdn.com/TveeMovie/aniplus/logoANI.mp4',
    openingMovie: '',
    isLoding: true,
    intReturn: 0,
  };
  _isMounted = false;
  //mouseDown = false
  timer = 0;
  interval = null;
  interval1 = null;
  componentDidMount = async () => {
    this._isMounted = true;

    // if (isMobile) {
    //   alert(
    //     "PC 전용 사이트로 모바일 해상도를 지원하지 않습니다.\n확인을 누르시면 전용 앱 또는 스토어로 이동합니다."
    //   );
    //   this._movieStore();
    // }

    this._getCurrentTitle();

    setTimeout(() => {
      this._onInitPlay();
    }, 1000);

    this._getBanner();
    this._changeTimeLine();

    window.addEventListener('scroll', this._scrollPostion);
    document.addEventListener('touchmove', this._scrollPostion);

    var body = document.querySelector('body');
    body.addEventListener('click', this.clickBodyEvent);

    document.addEventListener('fullscreenchange', (event) => {
      if (document.fullscreenElement) {
        this.setState({
          isFullScreen: true,
        });
      } else {
        this.setState({
          isFullScreen: false,
        });
      }
    });

    this.interval1 = setInterval(() => {
      ////console.log('call back...')
      this._getCurrentTitle();
      this._changeTimeLine();
    }, 1000 * 60);
  };

  componentWillUnmount = () => {
    // const { pip } = this.state;

    window.removeEventListener('scroll', this._scrollPostion);
    document.removeEventListener('touchmove', this._scrollPostion);
    var body = document.querySelector('body');
    body.removeEventListener('click', this.clickBodyEvent);
    clearInterval(this.interval1);
    //if(pip) {
    if (this._isMounted) {
      this.setState({
        url: '',
        playing: false,
        pip: false,
      });
    }
    //}

    this._isMounted = false;
  };
  _movieStore = () => {
    if (isIOS) {
      console.log('ios');
      setTimeout(function () {
        window.open('https://itunes.apple.com/kr/app/id687631772', '', '');
      }, 1500);

      window.location.href = 'aniplustv://';
    } else if (isAndroid) {
      console.log('andorid');
      setTimeout(function () {
        window.open(
          'https://play.google.com/store/apps/details?id=com.aniplustv.android',
          '',
          ''
        );
      }, 1500);

      window.location.href = 'aniplustv://';
    } else {
      setTimeout(function () {
        window.open(
          'https://play.google.com/store/apps/details?id=com.aniplustv.android',
          '',
          ''
        );
      }, 1500);
    }
  };

  _liveStop = () => {
    // const { pip } = this.state;

    //if(pip) {
    this.setState({
      //url: '',
      playing: false,
      pip: false,
    });
    //}
  };
  _scrollPostion = (e) => {
    // const { pip, loaded } = this.state
    // const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
    // const body = document.body;
    // const html = document.documentElement;
    // const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    // const windowBottom = windowHeight + window.pageYOffset;
    //console.log(windowBottom)
    /*
        if(windowBottom >= 1200){ // 3000px (arbitrary - put whatever point you need there.)
           
            if(pip === false && loaded === 1) {
                this.setState({
                    pip: true
                })
            }
        } else {
            if(pip === true && loaded === 1) {
                this.setState({
                    pip: false
                })
            }
        }
        */
  };

  _msToTime = (duration) => {
    // let milliseconds = parseInt((duration%1000) / 1000)
    let seconds = parseInt((duration / 1000) % 60);
    let minutes = parseInt((duration / (1000 * 60)) % 60);
    let hours = parseInt((duration / (1000 * 60 * 60)) % 24);

    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;

    return hours + ':' + minutes + ':' + seconds;
  };
  _handleVolumeEvent = (event) => {
    event.preventDefault();
    let start;
    let width;
    //console.log(event.type)
    //console.log(event.clientX)
    //console.log(this.mouseDown)
    if (event.type === 'mousedown') {
      ////console.log('mouseDown..')
      ////console.log(event.clientX)
      this.mouseDown = true;
      start = $('.sound_line').offset();
      width = $('.sound_line').width();
      //console.log(start.left, width)
      if (event.clientX >= start.left + width) {
        this.setState({
          volume: 1,
        });
      } else if (event.clientX <= start.left) {
        this.setState({
          volume: 0,
        });
      } else {
        const val = (event.clientX - start.left) / width;
        //console.log(val)
        this.setState({
          volume: val,
        });
      }
    } else if (event.type === 'mouseup') {
      this.mouseDown = false;
      setTimeout(() => {
        this.setState({
          isHovering: false,
        });
      }, 1000);
      //console.log('mouseUp..')
    } else if (event.type === 'mousemove') {
      if (this.mouseDown) {
        const start = $('.sound_line').offset();
        const width = $('.sound_line').width();
        if (event.clientX >= start.left + width) {
          this.setState({
            volume: 1,
          });
        } else if (event.clientX <= start.left) {
          this.setState({
            volume: 0,
          });
        } else {
          const val = (event.clientX - start.left) / width;
          //console.log(val)
          this.setState({
            volume: val,
          });
        }
      }
    }
    //console.log(this.mouseDown)
  };

  _getBanner = async () => {
    const result = await this._getBannerApi();
    const intReturn = result.data[0].intReturn;
    const barBannerList = result.data[0].listData;

    if (intReturn === 0) {
      if (this._isMounted) {
        this.setState({
          barBannerList,
        });
      }
    }
  };
  _getBannerApi = () => {
    const { apiUrl } = this.props;

    return axios(apiUrl + '/topBannerBar')
      .then((response) => response)
      .catch((error) => {
        //console.log('error....')
      });
  };
  _onInitPlay = async () => {
    const { loginId, aParam, serviceEndDate } = this.props;
    const date = new Date();
    const timeStemp = moment(date).add(10, 'minutes').format('YYYYMMDDHHmmss');

    if (moment(new Date()).format('YYYY-MM-DD HH:mm:ss') > serviceEndDate) {
      alert('LIVE 서비스가 종료되었습니다.');
      return null;
    }

    //console.log(timeStemp)

    if (loginId === null || loginId === undefined || loginId === '') {
      //alert('로그인 후 이용할 수 있습니다.')
    } else {
      //const subPart = "0" + "/" + loginId
      const subPart = '0/' + loginId + '@' + aParam;
      let crypParam = timeStemp + '|was|' + subPart;

      const base64Data = await this._getBase64Encode(crypParam);
      crypParam = base64Data.data.codeString;
      //console.log(loginId)
      //console.log(crypParam)

      const result = await this._onPlayApi(crypParam);

      if (result) {
        const intReturn = result.data[0].intReturn;

        //console.log('============================>')
        //console.log(intReturn)

        if (intReturn === 0) {
          //console.log('성공..')
          const contentSerial = result.data[0].contentSerial;
          // const contentPartSerial = result.data[0].contentPartSerial;
          // const subPartSerial = result.data[0].subPartSerial;
          // const part = result.data[0].part;
          const liveServer480 = result.data[0].liveServer480;
          const liveServer720 = result.data[0].liveServer720;
          const liveServer1080 = result.data[0].liveServer1080;

          //console.log(contentSerial)
          if (this._isMounted) {
            this.setState({
              intReturn,
              url: liveServer720,
              liveServer480,
              liveServer720,
              liveServer1080,
              contentSerial,
              chatOn: false, //채팅 기본 옵션은 미참여
              loadingShow: false, //,
              //playing: true
            });

            this._onPlayerOver();
            /*
                        setTimeout(() => {
                            this.setState({
                                //loadingShow: false,
                                playing: true
                            })
                        }, 1500)
                        */
          }
        } else if (intReturn === -1) {
          alert('오류가 발생했습니다.');
        } else if (intReturn === -2 || intReturn === -3) {
          //alert('멤버십 가입후 관람이 가능합니다.')
        } else if (intReturn === -4) {
          alert('19세 미만은 관람이 불가한 작품입니다.');
        } else if (intReturn === -1000) {
          alert('서비스가 종료되었습니다.');
        }
      }
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };
  _onPlayApi = (crypParam) => {
    const { apiUrl, loginId, authId, history } = this.props;
    let token = new Date();
    token = moment(token).format('YYYYMMDDhhmmss');
    token = Base64.encode(token);
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');

    return axios
      .post(
        apiUrl + '/getLiveUrl',
        {
          params: {
            userid: loginId,
            authId: authId,
            crypParam: crypParam,
            token: token,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken();
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async () => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    const rt = localStorage.getItem('rt');

    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      this._onInitPlay();
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  _onReady = () => {
    // const { played } = this.state;
    // console.log('ready...')
    if (this._isMounted) {
      setTimeout(() => {
        //alert(0)
        this.setState({
          //loaded: 1,
          playing: true,
          isLoding: false,
          muted: false,
        });
      }, 500);
    }
  };

  _getCurrentTitle = async () => {
    const result = await this._getCurrentTitleApi();

    const intReturn = result.data[0].intReturn;
    const currentData = result.data[0].listData;

    if (intReturn === 0) {
      if (this._isMounted) {
        this.setState({
          currentData,
          contentSerial: currentData[0].contentSerial,
        });
      }
    }
  };
  _getCurrentTitleApi = () => {
    const { apiUrl } = this.props;

    return axios(apiUrl + '/liveCurrentTitle')
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  _onChangeBitrate = (bitrate) => {
    const { liveServer480, liveServer720, liveServer1080 } = this.state;
    let videoSource = '';

    if (bitrate === '720P') {
      videoSource = liveServer720;
    } else if (bitrate === '1080P') {
      videoSource = liveServer1080;
    } else if (bitrate === '480P') {
      videoSource = liveServer480;
    } else {
      videoSource = liveServer720;
    }

    this.setState({
      url: videoSource,
      //played: played
    });
  };
  _onPlayToggle = () => {
    const { playing } = this.state;

    if (this._isMounted) {
      this.setState({
        playing: !playing,
      });

      if (playing) {
        this._onPlayerOver();
      } else {
        this._onPlayerOut();
      }
    }
  };
  _onStop = () => {
    // const { url } = this.state;
    this.setState({
      url: '',
      //played: 0,
      //loaded: 0,
      playing: false,
    });
  };
  _onDuration = (duration) => {
    const { played } = this.state;
    this.setState({
      duration,
    });
    setTimeout(() => {
      //alert(0)
      this.video.seekTo(parseFloat(played));
    }, 500);
  };
  _onVolumeChange = (e) => {
    const volume = parseFloat(e.target.value);
    this.setState({
      volume,
    });
  };
  _onToggleMuted = () => {
    this.setState({ muted: !this.state.muted });
  };
  _onFullscreen = () => {
    const element = document.getElementsByClassName('play_group')[0];
    if (screenfull.isFullscreen) {
      document.exitFullscreen();
    } else {
      screenfull.request(element);
    }
    clearInterval(this.interval);
  };
  _getBase64Encode = (codeString) => {
    const { aspUrl, pkg, loginId } = this.props;
    //console.log(pkg)
    return axios(
      aspUrl +
        '/base64encode_wd.asp?codeString=' +
        codeString +
        '&p=' +
        pkg +
        '&i=' +
        loginId
    )
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  _getBase64Decode = (codeString) => {
    const { aspUrl } = this.props;
    //console.log(aspUrl + '/base64decode.asp?codeString=' + codeString)
    return axios(aspUrl + '/base64decode.asp?codeString=' + codeString)
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  _goLogin = () => {
    const { history } = this.props;
    history.push('/login');
  };
  _onEnded = () => {
    const { logoPlay, currentData } = this.state;
    if (logoPlay) {
      this.setState({
        imgShow: true,
        playing: false,
      });
    } else {
      this.setState({
        videoUrl: 'https://jjmp4.ofscdn.com' + currentData[0].opening,
        playing: true,
      });
    }
  };
  _changeTimeLine = () => {
    ////console.log('======<')
    ////console.log(date)
    const date = moment(new Date()).format('YYYY-MM-DD');
    this._getTimeLine(date);
  };
  _getTimeLine = async (date) => {
    const result = await this._getTimeLineApi(date);
    const intReturn = result.data[0].intReturn;
    const timeLineList = result.data[0].listData;

    //console.log(date)
    //console.log(timeLineList)

    if (intReturn === 0) {
      this.setState({
        timeLineList,
      });
    }
  };
  _getTimeLineApi = (date) => {
    const { apiUrl } = this.props;

    return axios(apiUrl + '/dateTimeLine?date=' + date)
      .then((response) => response)
      .catch((error) => {
        //console.log(error)
      });
  };
  _playBannerHide = () => {
    this.setState({
      playBannerShow: false,
    });
  };
  _togglePip = () => {
    const { playing, pip } = this.state;
    if (this._isMounted) {
      if (playing) {
        this.setState({
          pip: !pip,
          playing: true,
        });
      } else {
        toast.warn('화면이 로딩 후 PIP 사용이 가능합니다.');
      }
    }
  };
  _onEnablePIP = () => {
    this.setState({
      pip: true,
      playing: true,
    });
  };
  _onDisablePIP = () => {
    this.setState({
      pip: false,
      playing: true,
    });
  };
  _onChatChange = (chatOn) => {
    //console.log(chatOn)
    this.setState({
      chatOn: !chatOn,
    });
  };
  _onPlayerOver = () => {
    const { isHovering } = this.state;

    clearInterval(this.interval);

    if (this._isMounted) {
      if (isHovering === false) {
        this.setState({
          isHovering: true,
        });
      }

      this.interval = setInterval(() => {
        this._onMouseMoveCheck();
      }, 1000);
    }
  };
  _onPlayerOut = () => {
    this.timer = 0;
    clearInterval(this.interval);

    this.setState({
      isHovering: false,
    });
  };
  _onPlayerMove = () => {
    const { isHovering } = this.state;

    if (isHovering) {
      this.timer = 0;
    }
    ////console.log(isHovering)
  };
  _onMouseMoveCheck = () => {
    const { isHovering, playing } = this.state;
    ////console.log('aaa')

    //console.log(this.timer)
    if (playing) {
      if (isHovering) {
        this.timer = this.timer + 1;

        if (this.timer >= 5) {
          this.timer = 0;
          clearInterval(this.interval);

          this.setState({
            isHovering: false,
          });
        }
      } else {
        this.timer = 0;
        clearInterval(this.interval);
      }
    } else {
      this.setState({
        isHovering: true,
      });
    }
  };
  _toggleMuted = () => {
    const { muted } = this.state;
    this.setState({
      muted: !muted,
    });
  };
  /*
    _toggleBack = () => {
        const { menuBackOn } = this.state;
        this.setState({
            menuBackOn: !menuBackOn
        })
        clearInterval(this.interval)
    }
    */
  /*
    _toggleMenu = () => {
        const { menuPart } = this.state;
        this.setState({
            menuPart: !menuPart
        })
    }
    */
  _togglePlay = () => {
    const { menuPlay } = this.state;
    this.setState({
      menuPlay: !menuPlay,
    });
  };
  /*
    _togglePrev10 = () => {
        const { menuPrev10 } = this.state;
        this.setState({
            menuPrev10: !menuPrev10
        })
    }
    _toggleNext10 = () => {
        const { menuNext10 } = this.state;
        this.setState({
            menuNext10: !menuNext10
        })
    }
    */
  _toggleSetting = () => {
    const { menuSetting } = this.state;
    this.setState({
      menuSetting: !menuSetting,
    });
  };
  _toggleFull = () => {
    const { menuFull } = this.state;
    this.setState({
      menuFull: !menuFull,
    });
  };
  _toggleMenuPip = () => {
    const { menuPip } = this.state;

    this.setState({
      menuPip: !menuPip,
    });
  };
  _toggleSound = () => {
    const { menuSound } = this.state;

    this.setState({
      menuSound: !menuSound,
    });
  };
  _openTimeline = () => {
    const { setTimeline } = this.props;
    setTimeline(true);
  };
  _goTicket = () => {
    const { history } = this.props;
    history.push('/ticket');
  };
  _onProgress = (state) => {};
  _showMenu = () => {
    const { isHovering } = this.state;

    //console.log(isHovering)
    if (isHovering) {
      this._onPlayerOut();
    } else {
      this._onPlayerOver();
    }
  };
  _outMenu = () => {
    const { isHovering } = this.state;

    if (isHovering) {
      this._onPlayerOut();
    }
  };
  _onVolumeUp = () => {
    const { volume } = this.state;
    //console.log(parseFloat(volume.toFixed(1)) + 0.1)
    if (parseFloat(volume.toFixed(1)) + 0.1 < 1) {
      this.setState({
        volume: parseFloat(volume.toFixed(1)) + 0.1,
      });
    } else {
      this.setState({
        volume: 1,
      });
    }
  };
  _onVolumeDonw = () => {
    const { volume } = this.state;

    if (parseFloat(volume.toFixed(1)) - 0.1 > 0) {
      this.setState({
        volume: parseFloat(volume.toFixed(1)) - 0.1,
      });
    } else {
      this.setState({
        volume: 0,
      });
    }
  };
  _onKeyDown = (keyName, e, handle) => {
    ////console.log("test:onKeyDown", keyName, e, handle)
    e.preventDefault();
  };
  _onBack = () => {
    const { history, setPlayUrl } = this.props;
    if (this.pos === 'pop') {
      setPlayUrl('');
    } else {
      history.goBack();
    }
  };
  _onKeyUp = (keyName, e, handle) => {
    ////console.log(keyName)
    //e.preventDefault()
    //e.stopPropagation();
    //e.stopImmediatePropagation();
    //e.cancelBubble = true

    if (keyName === 'space') {
      this._onPlayToggle();
    } else if (keyName === 'up') {
      //볼륨 10+
      this._onVolumeUp();
    } else if (keyName === 'down') {
      //볼륨 10-
      this._onVolumeDonw();
    } else if (keyName === 'esc') {
      //
      this._onBack();
    } else if (keyName === 'pageup') {
      //전체보기
      this._onFullscreen();
    }
    ////console.log("test:onKeyDown", keyName, e, handle)
  };
  _goBanner = () => {
    window.open(
      'https://e.kakao.com/t/bang-dream-girls-band-party-pico',
      '',
      ''
    );
    //window.open('https://game.kakao.com/ar/worldflipper?rtc=atb_E-OAD00MZ001', '', '')
  };
  _onError = (e) => {
    console.log(e);

    if (this._isMounted) {
      this.setState({
        playing: false,
        played: 0,
        loaded: 0,
        muted: false,
        duration: 0,
        isHovering: true,
      });
    }
  };
  render() {
    const { loginId, imgUrl, serviceEndDate } = this.props;
    const {
      title,
      url,
      playing,
      volume,
      muted,
      contentSerial,
      currentData,
      imgShow,
      timeLineList,
      barBannerList,
      playBannerShow,
      intReturn,
      pip,
      isHovering,
      isFullScreen,
      menuPlay,
      menuFull,
      menuPip,
      menuSound,
      videoUrl,
      isLoding,
    } = this.state;

    return (
      <Fragment>
        {/* {isMobile ? (
          <div
            style={{
              color: "#fff",
              textAlign: "center",
              paddingTop: 100,
            }}
          >
            <p>
              <img src="/img/logo.png" style={{ width: 130 }} />
            </p>
            <p style={{ paddingTop: 20, fontSize: 15 }}>
              모바일에서 지원되지 않는 페이지입니다.
            </p>
            <p style={{ fontSize: 15 }}>전용앱을 이용해주세요.</p>
            <p
              onClick={this._movieStore}
              style={{
                paddingTop: 15,
                color: "#ff5d24",
                fontSize: 15,
                fontWeight: 800,
              }}
            >
              전용앱으로 열기
            </p>
          </div>
        ) : ( */}
        <>
          <Helmet>
            <title>한일 동시방영 라이브 채널</title>
            <meta
              name="title"
              content="한일 동시방영 라이브 채널- 애니플러스"
            />
            <meta
              name="description"
              content="가장 빠른 라이브 방영 애니플러스 - 스파이 패밀리, 진격의 거인, 주술회전"
            />
            <meta name="robots" content="index,follow" />
            <meta
              name="keywords"
              content="라이브 방송, 애니플러스, 스파이 패밀리, 진격의 거인, 주술회전, 한일동시방영, 애니메이션"
            />

            <meta property="og:type" content="website" />
            <meta
              property="og:title"
              content="한일 동시방영 라이브 채널- 애니플러스"
            />
            <meta
              property="og:description"
              content="가장 빠른 라이브 방영 애니플러스 - 스파이 패밀리, 진격의 거인, 주술회전"
            />
            <meta property="og:url" content="https://www.aniplustv.com/live" />

            <meta name="twitter:card" content="summary" />
            <meta
              name="twitter:title"
              content="한일 동시방영 라이브 채널- 애니플러스"
            />
            <meta
              name="twitter:description"
              content="가장 빠른 한일동시방영 애니플러스 - 스파이 패밀리, 진격의 거인, 주술회전"
            />
            <meta
              name="twitter:domain"
              content="https://www.aniplustv.com/live"
            />

            <link rel="canonical" href="https://www.aniplustv.com/live" />
          </Helmet>

          <div className="content">
            <Hotkeys
              keyName="space,left,right,up,down,esc"
              onKeyDown={this._onKeyDown}
              onKeyUp={this._onKeyUp}
            >
              {/*<div className="height_70"></div>*/}

              <div className="live_wrap live_group ">
                <div className="live_play ">
                  {loginId === null ||
                  loginId === undefined ||
                  loginId === '' ? (
                    <div className="live_top_login" style={{ zIndex: 50 }}>
                      <span>
                        {/*<em>3:23</em>*/}
                        {currentData ? currentData[0].title : ''} Opening MV
                        재생중입니다.
                      </span>
                      <span onClick={this._goLogin}>
                        로그인후 이용할 수 있습니다.
                        <a
                          style={{ cursor: 'pointer' }}
                          onClick={this._goLogin}
                        >
                          <img src={imgUrl + '/img/live_img/login_btn.png'} />
                        </a>
                      </span>
                    </div>
                  ) : intReturn !== 0 ? (
                    <div className="live_top_login">
                      <span>
                        {/*<em>3:23</em>*/}
                        {currentData ? currentData[0].title : ''} Opening MV
                        재생중입니다.
                      </span>
                      <span>멤버십 가입후 시청하실 수 있습니다.</span>
                    </div>
                  ) : null}

                  {/*배너 구좌... 오프닝 나올때 배너 노출 가능.*/}
                  {intReturn !== 0 ? (
                    playing ? (
                      playBannerShow ? (
                        barBannerList ? (
                          barBannerList[0] ? (
                            <div
                              className="live_top_baner"
                              style={{ zIndex: 50 }}
                            >
                              <div style={{ backgroundColor: '#fff03c' }}>
                                {/*
                                                <img src="/img/live_img/kakao.jpg" style={{cursor: 'pointer', borderRadius: 15}} onClick={this._goBanner}/><a style={{cursor: 'pointer'}} onClick={this._playBannerHide}><img src="/img/live_img/close_100.png"/></a>
                                                */}
                                <img
                                  src={imgUrl + '/img/live_img/baner_img.png'}
                                  style={{ cursor: 'pointer' }}
                                  onClick={this._goBanner}
                                />
                                <a
                                  style={{ cursor: 'pointer' }}
                                  onClick={this._playBannerHide}
                                >
                                  <img
                                    src={imgUrl + '/img/live_img/close_100.png'}
                                  />
                                </a>
                              </div>
                            </div>
                          ) : null
                        ) : null
                      ) : null
                    ) : null
                  ) : null}

                  {/*마우스 오버 */}

                  <div className="play_group">
                    {/*오프닝 또는 스틸컷*/}
                    {loginId === '' ||
                    loginId === undefined ||
                    loginId === null ? (
                      currentData ? (
                        currentData[0].opening ? (
                          !imgShow ? (
                            <ReactPlayer
                              url={videoUrl}
                              //className='bg_img'
                              playing={true}
                              //url={playUrl}
                              volume={0.5}
                              muted={true}
                              //onReady={this._onReady}
                              onEnded={this._onEnded}
                              //style={{width: wSize, height: hSize}}
                              width={'100%'}
                              height={'100%'}
                              playsinline={true}
                            />
                          ) : (
                            <img src={currentData[0].overImg} />
                          )
                        ) : (
                          <img src={currentData[0].overImg} />
                        )
                      ) : null
                    ) : intReturn === 0 ? (
                      <div style={{ height: '100%' }}>
                        <Fragment>
                          {isMobile ? null : isHovering ? (
                            <div className="live_hover">
                              <div className="live_hover_group">
                                {/*마우스 오버시 마다 정보 새롭게 로드 할것...*/}
                                <div
                                  onClick={this._showMenu}
                                  style={{ width: '100%' }}
                                >
                                  <LiveCurrentTitle currentData={currentData} />
                                </div>
                                <div>
                                  <div className="float_left">
                                    <span
                                      style={{
                                        cursor: 'pointer',
                                        zIndex: 100,
                                      }}
                                      onClick={this._onPlayToggle}
                                      onMouseEnter={this._togglePlay}
                                      onMouseLeave={this._togglePlay}
                                    >
                                      {playing ? (
                                        menuPlay ? (
                                          <img
                                            src={
                                              imgUrl +
                                              '/img/player/pause_btn_o.png'
                                            }
                                            style={{
                                              cursor: 'pointer',
                                              zIndex: 100,
                                            }}
                                            onClick={this._onPlayToggle}
                                          />
                                        ) : (
                                          <img
                                            src={
                                              imgUrl +
                                              '/img/player/pause_btn.png'
                                            }
                                          />
                                        )
                                      ) : menuPlay ? (
                                        <img
                                          src={
                                            imgUrl +
                                            '/img/player/play_btn_o.png'
                                          }
                                        />
                                      ) : (
                                        <img
                                          src={
                                            imgUrl + '/img/player/play_btn.png'
                                          }
                                        />
                                      )}
                                    </span>

                                    <span
                                      style={{
                                        cursor: 'pointer',
                                        zIndex: 10,
                                      }}
                                      onMouseEnter={this._toggleSound}
                                      onMouseLeave={this._toggleSound}
                                      onClick={this._toggleMuted}
                                    >
                                      {muted ? (
                                        menuSound ? (
                                          <img
                                            src={
                                              imgUrl +
                                              '/img/player/sound_off_btn_o.png'
                                            }
                                          />
                                        ) : (
                                          <img
                                            src={
                                              imgUrl +
                                              '/img/player/sound_off_btn_o.png'
                                            }
                                          />
                                        )
                                      ) : menuSound ? (
                                        <img
                                          src={
                                            imgUrl +
                                            '/img/player/sound_btn_o.png'
                                          }
                                        />
                                      ) : (
                                        <img
                                          src={
                                            imgUrl + '/img/player/sound_btn.png'
                                          }
                                        />
                                      )}
                                    </span>

                                    <div
                                      className="sound_line"
                                      style={{ zIndex: 100000 }}
                                      onMouseDown={this._handleVolumeEvent}
                                      onMouseUp={this._handleVolumeEvent}
                                      onMouseMove={this._handleVolumeEvent}
                                    >
                                      <div
                                        style={{
                                          width:
                                            volume === 1
                                              ? 0.9 * 100
                                              : volume * 100 + '%',
                                        }}
                                      ></div>
                                      <em
                                        style={{
                                          left:
                                            volume === 1
                                              ? 0.8 * 100
                                              : volume * 100 + '%',
                                        }}
                                      ></em>
                                      <div
                                        className="sound_line_remain"
                                        style={{
                                          background: 'rgb(255, 255, 255, 0.3)',
                                        }}
                                      ></div>
                                    </div>

                                    {/*<span>23:40 - 24:20</span>*/}
                                  </div>
                                  <div className="float_right">
                                    {/*
                                                                                <span style={{cursor: 'pointer', zIndex: 10}} onClick={this._toggleSetting}>
                                                                                    { settingShow ? (
                                                                                        <div className="set_pop">
                                                                                            <dl>
                                                                                                <dt>화질설정</dt>
                                                                                                <dd><a href="#" className="on">자동</a></dd>
                                                                                                <dd><a href="#">1080P</a></dd>
                                                                                                <dd><a href="#">720P</a></dd>
                                                                                            </dl>
                                                                                            <dl>
                                                                                                <dt>재생설정</dt>
                                                                                                <dd><a href="#">연속재생</a></dd>
                                                                                                <dd><a href="#">오픈닝 스킵</a></dd>
                                                                                                <dd><a href="#">엔딩 스킵</a></dd>
                                                                                            </dl>
                                                                                        </div>
                                                                                    ) : null }
                                                                                </span>
                                                                                */}
                                    <div
                                      style={{
                                        position: 'relative',
                                        right: 52,
                                        zIndex: 99999,
                                        cursor: 'pointer',
                                      }}
                                      onMouseEnter={this._toggleMenuPip}
                                      onMouseLeave={this._toggleMenuPip}
                                      onClick={this._togglePip}
                                    >
                                      {menuPip ? (
                                        <img
                                          src={
                                            imgUrl + '/img/player/pop_btn_o.png'
                                          }
                                        />
                                      ) : (
                                        <img
                                          src={
                                            imgUrl + '/img/player/pop_btn.png'
                                          }
                                        />
                                      )}
                                    </div>
                                    <div
                                      style={{
                                        position: 'relative',
                                        right: 0,
                                        top: -45,
                                        zIndex: 99999,
                                        cursor: 'pointer',
                                      }}
                                      onMouseEnter={this._toggleFull}
                                      onMouseLeave={this._toggleFull}
                                      onClick={this._onFullscreen}
                                    >
                                      {isFullScreen ? (
                                        menuFull ? (
                                          <img
                                            src={
                                              imgUrl + '/img/player/unall_o.png'
                                            }
                                          />
                                        ) : (
                                          <img
                                            src={
                                              imgUrl + '/img/player/unall.png'
                                            }
                                          />
                                        )
                                      ) : menuFull ? (
                                        <img
                                          src={imgUrl + '/img/player/all_o.png'}
                                        />
                                      ) : (
                                        <img
                                          src={imgUrl + '/img/player/all.png'}
                                        />
                                      )}
                                    </div>
                                  </div>
                                  <div className="clear"></div>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {isMobile ? null : isLoding === false ? null : (
                            <div
                              className="vod_loading"
                              style={{
                                zIndex: 9999,
                                position: 'absolute',
                                top: window.innerHeight / 2,
                                left: '50%',
                                marginLeft: -100,
                                marginTop: -100,
                              }}
                            >
                              <img
                                src={imgUrl + '/img/vod/vod_loading.png'}
                                style={{ width: 50 }}
                              />
                              <div style={{ color: '#fff', paddingTop: 10 }}>
                                영상을 불러오고 있습니다.
                              </div>
                            </div>
                          )}
                          {moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
                          serviceEndDate ? null : (
                            <div
                              onClick={this._showMenu}
                              style={{ zIndex: 100 }}
                            >
                              <ReactPlayer
                                url={url}
                                playing={playing}
                                controls={isMobile ? true : false}
                                muted={muted}
                                ref={(ref) => (this.video = ref)}
                                light={false}
                                width="100%"
                                height="100%"
                                volume={volume}
                                //playbackRate={playbackRate}
                                onReady={this._onReady}
                                //onProgress={this._onProgress}
                                //onDuration={this._onDuration}
                                onSeek={(e) => console.log('onSeek', e)}
                                onStart={() => console.log('onStart')}
                                //onEnded={this._onProgress}
                                onError={(e) => this._onError(e)}
                                onEnablePIP={this._onEnablePIP}
                                onDisablePIP={this._onDisablePIP}
                                pip={pip}
                                playsinline={true}
                              />
                            </div>
                          )}
                        </Fragment>
                      </div>
                    ) : /*
                                            <div style={{width: 1080, height: 720, textAlign: 'center', verticalAlign: 'center'}}>
                                                 <div className="vod_loading"><img src="/img/vod/vod_loading.png" style={{width: 60, height: 62}}/></div>
                                            </div>
                                            */
                    currentData ? (
                      currentData[0].opening ? (
                        !imgShow ? (
                          <ReactPlayer
                            url={videoUrl}
                            //className='bg_img'
                            playing={true}
                            //url={playUrl}
                            volume={0.5}
                            muted={true}
                            //onReady={this._onReady}
                            onEnded={this._onEnded}
                            //style={{width: wSize, height: hSize}}
                            width={'100%'}
                            height={'100%'}
                            onProgress={this._onProgress}
                            playsinline={true}
                          />
                        ) : (
                          <img src={currentData[0].overImg} />
                        )
                      ) : (
                        <img src={currentData[0].overImg} />
                      )
                    ) : null}
                  </div>
                </div>

                {currentData ? (
                  <InfoLeft
                    img={currentData[0].img}
                    contentSerial={currentData[0].contentSerial}
                    title={currentData[0].title}
                    subTitle={currentData[0].subTitle}
                    contentSysnopsis={currentData[0].contentSysnopsis}
                    outputStart={currentData[0].outputStart}
                    outputEnd={currentData[0].outputEnd}
                    ratio={currentData[0].ratio}
                    gubun={currentData[0].gubun}
                    timeLineList={timeLineList}
                  />
                ) : null}

                {/*
                            <div className="live_right">
                                <Layout 
                                    intReturn  = {intReturn}
                                    img = {currentData[0].img}
                                    title = { currentData[0].title }
                                    subTitle = { currentData[0].subTitle }
                                    contentSysnopsis = { currentData[0].contentSysnopsis }
                                    onChatChange = {this._onChatChange}
                                    chatOn = {chatOn}
                                    contentSerial={currentData[0].contentSerial}
                                />
                            </div>
                            */}
              </div>

              <div className="padding_70">
                {/* timeLineList ? (
                            <div className="live_pairing">
                                <h1><strong>이시간 이후 LIVE 방송 편성표</strong><div><em className="on"></em><em></em><em></em><a style={{cursor: 'pointer'}} onClick={this._openTimeline} >더보기</a></div></h1>
                                <div className="live_pairing_group">
                                  
                                    
                                    <DateTimeLine 
                                        timeLineList = {timeLineList}
                                    />
                                </div>
                            </div>
                        ) : null*/}
                {barBannerList ? (
                  barBannerList[0] ? (
                    <div className="live_top_baner" style={{ zIndex: 1000 }}>
                      <BarBannerItem
                        index={1}
                        bannerFile={barBannerList[0].bannerFile}
                        bannerFile_s={barBannerList[0].bannerFile_s}
                        LinkURL={barBannerList[0].LinkURL}
                        Linktarget={barBannerList[0].Linktarget}
                        LinkURL_M={barBannerList[0].LinkURL_M}
                        Linktarget_M={barBannerList[0].Linktarget_M}
                        idx={barBannerList[0].idx}
                        comment={barBannerList[0].comment}
                        adComIdx={barBannerList[0].adComIdx}
                        pageCode={barBannerList[0].pageCode}
                      />
                    </div>
                  ) : null
                ) : null}

                {contentSerial ? (
                  <ContentPart
                    contentSerial={contentSerial}
                    playToggle={this._onPlayToggle}
                    liveStop={this._liveStop}
                  />
                ) : null}
                {contentSerial ? (
                  <SameGenreContent contentSerial={contentSerial} />
                ) : null}

                {/*barBannerList ? barBannerList[0] ? (
                            <BarBannerItem
                                index={1} 
                                bannerFile={barBannerList[0].bannerFile}
                                LinkURL={barBannerList[0].LinkURL}
                                Linktarget={barBannerList[0].Linktarget}

                            />
                        ) : null : null */}

                <div></div>
                <SameTimeContent />
                <PopularContent />
              </div>
            </Hotkeys>
          </div>
          <Footer />
        </>
        {/* )} */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(LivePlayer)));
